import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import './style.scss';
import IconBearingBSF from 'svgIcons/MotionPortalIcons/IconBearingBSF';
import IconBearingBPFI from 'svgIcons/MotionPortalIcons/IconBearingBPFI';
import IconBearingBPFO from 'svgIcons/MotionPortalIcons/IconBearingBPFO';

const HarmonicsTableComponent = ({
    title,
    data,
    frequencyUnitSymbol,
    dividerEvery,
}) => {

    const getLineClass = (item) => {
        if (item.lineStyle === 'Dot') { return 'Dot'; }
        if (item.lineStyle === 'DashDot') { return 'DashDot'; }
        if (item.lineStyle === 'LongDash') { return 'LongDash'; }
    };

    const getDisplayName = (item, index) => item?.name ? String(item.name) : String(index + 1);

    const renderLineIcon = (item) => {
        const cls = getLineClass(item);
        switch (cls) {
            case 'Dot':
                return <span className={`line-icon ${cls}`}><IconBearingBSF /></span>;
            case 'DashDot':
                return <span className={`line-icon ${cls}`}><IconBearingBPFI /></span>;
            case 'LongDash':
                return <span className={`line-icon ${cls}`}><IconBearingBPFO /></span>;
            default:
                return null;
        }
    };

    return (
        <div className='harmonics-horizontal-table'>
            <div className='widget-header-section'>
                <div className='header-label'>{title}</div>
            </div>

            <div className='widget-data-section'>
                {Array.isArray(data) && data.length > 0 ? data.map((item, i) =>
                    <React.Fragment key={item?.name || `hh-${i}`}>
                        <div className='harmonic-column' role='group' aria-label={getDisplayName(item, i)}>
                            <div className='col-top'>
                                {renderLineIcon(item)}
                                <span>{getDisplayName(item, i)}</span>
                            </div>
                            <div className='col-mid'>{item?.value ?? item?.frequencyValue} {frequencyUnitSymbol}</div>
                        </div>
                        {dividerEvery && (i + 1) % dividerEvery === 0 && i !== data.length - 1 &&
                            <div className='vertical-divider' aria-hidden />
                        }
                    </React.Fragment>
                ) :
                    <span className='no-data-text'>
                        {translate('ABB.Powertrain.Frontend.noDataLabel')}
                    </span>
                }
            </div>
        </div>
    );
};

HarmonicsTableComponent.propTypes = {
    title: PropTypes.string,
    data: PropTypes.array,
    frequencyUnitSymbol: PropTypes.string,
    magnitudeUnitSymbol: PropTypes.string,
    dividerEvery: PropTypes.number,
};

export default HarmonicsTableComponent;
